import React, {useState, useEffect, useCallback,useRef } from "react";
import Header from "../../../Navbar/page";
import { useLocation, useNavigate } from "react-router-dom";
import Api from "../../../Api/Api";

function Scorepage() {
  const location = useLocation()
  const navigate=useNavigate()
  // const [time, setTime] = useState();
// console.log("location--->ssssssss",location.state)
// console.log("location--->Timer",location.state.timerDataTransfer)
  const stateValue = location.state.answer; // Assume location.state has a valid value
  const divisor = 20;
  const resultAnswer = stateValue / divisor;

   const centerDivRef = useRef(null);

  const resetParentProperty = () => {
    const parentDiv = centerDivRef.current.parentNode;
    const grandParentDiv = parentDiv.parentNode;
    const grandGrandParentDiv = grandParentDiv.parentNode;
    const headerSection = parentDiv.querySelector(".header-section");
    const headerMenu = parentDiv.querySelector(".header-menu");
    const sidebar = grandGrandParentDiv.querySelector(
      ".sidebar.break-point-sm.has-bg-image"
    );

    if (headerSection) headerSection.style.display = "";
    if (headerMenu) headerMenu.style.display = "";
    if (sidebar) sidebar.style.display = "";
  };


  const navnextlevel=()=>{   
      navigate("/")
      localStorage.removeItem("demoresult");
      // resetParentProperty()
      // console.log("hhhhhh")
  }

const timeInSec = () => {
    const timeInSec = location.state.timertemp;
  const timeParts = /(\d+)(ms|h|m|s)/g;
  // console.log("timeParts", timeParts)
  let totalSec = 0;

  let match;
  while ((match = timeParts.exec(timeInSec)) !== null) {
    let value = parseInt(match[1]); // Extract the numeric value
    let unit = match[2]; // Extract the unit
    // console.log("unit",unit, "val", value)

    if (unit === "h") totalSec += value * 3600; // Hours to seconds
    else if (unit === "m") totalSec += value * 60; // Minutes to seconds
    else if (unit === "s") totalSec += value; // Seconds remain the same
    else if (unit === "ms") totalSec += value / 1000; // Milliseconds to seconds
  }
  // console.log(totalSec,"sssssssssssssss")
  // setTime(totalSec);
  return totalSec;
}

  const UpdateData=async()=>{
    const time = timeInSec();
    // console.log(time, "=========time")
    // const gameidGet=localStorage.getItem("GameId")
    const datapatch={
      // ...(location.state.level === "easy" &&{
      firstLevelStatus:'Played',
      correctAnswer:resultAnswer,
      wrongAnswer:5-resultAnswer,
      // firstLevelScore:stateValue,
      score:stateValue,
      // timeTaken:location.state.timerDataTransfer,
      timeTaken:time,
      // gameId:location.state.gameid,
      // gameId:gameidGet,
    // }),
    //   ...(location.state.level === "medium" &&{
    //   secondLevelStatus:"Played",
    //   correctAnswer:resultAnswer,
    //   wrongAnswer:5-resultAnswer,
    //   // firstLevelScore:stateValue,
    //   score:stateValue,
    //   // timeTaken:location.state.timerDataTransfer,
    //   timeTaken:time,
    //   // gameId:location.state.gameid,
    //   // gameId:gameidGet,
    // }),
    //   ...(location.state.level === "hard" &&{
    //   thirdLevelStatus:'Played',
    //   thirdLevelScore:stateValue,
    // })

    }

    // console.log("resulllllll",datapatch)
    try {
      const response = await Api.post("/user/create-demo-score", datapatch);
      // console.log("response---->Score+++++++",response.data)
    } catch (error) {
      console.log(error)
    }
  }

  const Perviewpagefunction=()=>{
    navigate("/gamearea")
  }
  // const formatTime = (time) => {
  //   const hours = Math.floor((time / 3600000) % 24);
  //   const minutes = Math.floor((time / 60000) % 60);
  //   const seconds = Math.floor((time / 1000) % 60);
  //   const milliseconds = Math.floor((time % 1000));
  //   return `${hours}h ${minutes}m ${seconds}s ${milliseconds}ms`;
  // };


  const formatTime = (time) => {
    const hours = Math.floor((time / 3600000) % 24);
    const minutes = Math.floor((time / 60000) % 60);
    const seconds = Math.floor((time / 1000) % 60);
    const milliseconds = Math.floor((time % 1000) );
    // return `${hours}h ${minutes}m ${seconds}s ${milliseconds}ms`;
    return `${seconds}s`;

  };

  useEffect(() => {
    timeInSec();
  }, [location.state.timertemp]);

  useEffect(()=>{
    if (
      !localStorage.getItem("demoresult") ||
      localStorage.getItem("demoresult") === ""
    ) {
    UpdateData();
    window.scrollTo({ top: 0, behavior: 'smooth' });
      localStorage.setItem("demoresult", "demoresult");
    }else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  },[])

    useEffect(() =>{
      if (centerDivRef.current) {
        const parentDiv = centerDivRef.current.parentNode;
        if (parentDiv) {
          const grandParentDiv = parentDiv.parentNode;
          const grandGrandParentDiv = grandParentDiv.parentNode;
          const headerSection = parentDiv.querySelector(".header-section");
          const headerMenu = parentDiv.querySelector(".header-menu");
          const sidebar = grandGrandParentDiv.querySelector(
            ".sidebar.break-point-sm.has-bg-image"
          );
  
          if (headerSection) headerSection.style.display = "none";
          if (headerMenu) headerMenu.style.display = "none";
          if (sidebar) sidebar.style.display = "none";
        }
      }
    },[]);

useEffect(() => {
    const handlePopState = (event) => {
      // print("pushkarsaraswat");
      // print(location.pathname);
      // console.log("Back/forward button pressed from:", location.pathname);

      // You can conditionally control navigation here
      if (location.pathname === "/demoresult") {
        // Redirect to a custom URL instead of going back
        navigate("/", { replace: true });
      } else {
        // Optionally allow default behavior
        // navigate(-1); // or do nothing and let it go back
      }
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [navigate, location]);
  return (
    <>
      {/* <Header /> */}
      <div className="wrapper overflow-hidden " ref={centerDivRef}>
        {/* <!-- Top content --> */}

        <div className="container position-relative">
          <form
            className="multisteps_form bg-white position-relative overflow-hidden height-auto"
            id="wizard"
            method="POST"
            action=""
          >
            {/* <!------------------------- Step-1 -----------------------------> */}

            <div className=" right-answer">
              <div className="popup-score">
                <h3 className="popup-head text-center">Result!</h3>
                <div className="u_result mb-5">
                  <div className="u_score" style={{ zIndex: 0 }}>
                    Your total Score:{" "}
                  </div>

                  <span>{stateValue} Points</span>
                </div>

                <div className="u_result mb-5" style={{ zIndex: 0 }}>
                  <div className="u_score">Your Correct answer: </div>

                  <span>{resultAnswer}/5</span>
                </div>
                {/* 
                <div className="u_result " style={{ zIndex: 0 }}>
                  <div className="u_score">Passing Score: </div>

                  <span>60 Points</span>
                </div> */}
                <div className="u_result " style={{ zIndex: 0 }}>
                  <div className="u_score">Timing: </div>
                  {/* <span>{location.state.timerDataTransfer.hours}:{location.state.timerDataTransfer.minutes}:{location.state.timerDataTransfer.seconds}:{location.state.timerDataTransfer.nanoseconds}</span> */}
                  {/* <span>{formatTime(location.state.timertemp).includes("0h 0m 0s 0ms") ? "" : formatTime(location.state.timertemp)}</span> */}
                  <span>{location.state.timertemp}</span>
                </div>

                <div className="pass_check bg-success text-white">
                  {resultAnswer >= 3
                    ? "Great job! You passed with an impressive score – well done!"
                    : "Good try! You can do better next time."}
                </div>
                <div
                  className=""
                  style={{
                    color: "red",
                    fontWeight: "600",
                    paddingTop: "10px",
                  }}
                >
                  {/* {resultAnswer >= 3 ? "" : "You cann't move to next level your score is less than 60 points"}  */}
                </div>
              </div>

              {/* {resultAnswer >= 3 ? (
                 <div className="form_btn">
                 <a >
                   <button
                     type="button"
                     className="next_btn rounded-pill text-uppercase text-white Hide-15"
                     id="nextBtn"
                     onClick={navnextlevel}
                   >
                     Next Level
                   </button>
                 </a>
               </div>
              ): (
                <>
              <div className="form_btn">
                <a>
                  <button
                    type="button"
                    className="next_btn rounded-pill text-uppercase text-white Hide-15"
                    id="nextBtn"
                   onClick={Perviewpagefunction}
                  >
                    New Game
                  </button>
                </a>
              </div>
              </>
              )} */}

              <div className="form_btn">
                <a>
                  <button
                    type="button"
                    className="next_btn rounded-pill text-uppercase text-white Hide-15"
                    id="nextBtn"
                    onClick={navnextlevel}
                  >
                    Home
                  </button>
                </a>
              </div>

              {/* <div className="form_btn">
                <a>
                  <button
                    type="button"
                    className="next_btn rounded-pill text-uppercase text-white Hide-15"
                    id="nextBtn"
                    onclick="nextPrev(1)"
                  >
                    New Game
                  </button>
                </a>
              </div> */}
            </div>

            {/* <!---------- Form Button ----------> */}
          </form>
        </div>
      </div>
    </>
  );
}

export default Scorepage;
